import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-vacant-commercial-property',
  templateUrl: './vacant-commercial-property.component.html',
  styleUrls: ['./vacant-commercial-property.component.css']
})
export class VacantCommercialPropertyComponent implements OnInit {
  datalist: any;
  data: any;

  constructor(private userService: UserService) { }

  ngOnInit() {
    this.getVacantCommProperty();
  }


  getVacantCommProperty(){
    this.data = this.userService.getVacantCommProperty();
    this.data.subscribe((response:any) => {
        console.log(response);
        this.datalist = response;


        // var occurences = this.datalist.reduce(function (r, row) {
        //     r[row.PD_Project_Name] = ++r[row.PD_Project_Name] || 1;
        //     return r;
        // }, {});
        
        // var result = Object.keys(occurences).map(function (key) {
        //     return { key: key, value: occurences[key] };
        // });

        // console.log(result);

    },(error:any) => {
        console.log(error);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/vacant-commercial-property/vacant-commercial-property.component.ts